import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import AuthCard from "@/components/AuthCard";
import { apiError } from "@/lib/errors";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.must_change_password) {
        toast.info("Please choose a new password to continue");
        nav("/change-password");
        return;
      }
      toast.success(`Welcome, ${user.name}`);
      nav(Object.values(user.permissions || {}).some(Boolean) ? "/dashboard" : "/");
    } catch (err) {
      toast.error(apiError(err, "Login failed"));
    } finally { setLoading(false); }
  };

  return (
    <AuthCard overline="Admin Access" title="SIGN IN" testid="login-page">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required
            className="rounded-sm border-slate-300" data-testid="login-email"/>
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-xs text-[#E11D48] hover:underline" data-testid="forgot-password-link">
              Forgot password?
            </Link>
          </div>
          <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required
            className="rounded-sm border-slate-300" data-testid="login-password"/>
        </div>
        <Button type="submit" disabled={loading}
          className="w-full bg-[#0A1128] text-white hover:bg-slate-800 rounded-sm font-heading tracking-wide h-11"
          data-testid="login-submit">
          {loading ? "Signing in..." : "SIGN IN"}
        </Button>
      </form>
      <Link to="/" className="block mt-6 text-sm text-slate-600 hover:text-[#0A1128]">← Back to public site</Link>
    </AuthCard>
  );
}
